module.exports = __webpack_public_path__ + "static/media/diagonal-left-border.fa8570da.svg";